import { APP_PERMISSIONS } from '@exam-center/permission';
import {
  ProctorRequestCreationFormProvider,
  ProcterRequestCreationPageHeader,
} from '@exam-center/proctor-request-creation';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function ProctorRequestCreationLayout() {
  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.PROCTOR_MANAGEMENT.PROCTOR_REQUEST.CREATE}>
      <ProctorRequestCreationFormProvider>
        <ProcterRequestCreationPageHeader />
        <Outlet />
      </ProctorRequestCreationFormProvider>
    </PermissionGuard>
  );
}
